import type { OperatorsName } from "@/stores/operator-store"
import { clsx, type ClassValue } from "clsx"
import { useEffect, useState } from "react"
import { twMerge } from "tailwind-merge"
import { get } from "idb-keyval"
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_ar"
import gregorian from "react-date-object/calendars/gregorian"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const mobileNormalize = (mobile: string) => {

  let formated = mobile

  if (mobile.startsWith('0')) {
    formated = mobile.replace('0', '')
  }
  if (mobile.startsWith('98')) {
    return mobile
  }

  return `98${formated}`
}


export type Message = {
  id: number,
  message: string,
  created_at: string
  is_admin: boolean,
  deliveryStatus?: "sending" | "sent" | "error",
  previewImages?: string[],
}

export type Acc = Record<string, Array<Message>>

export function groupMessagesByDate(messages: Array<Message>) {
  return messages.reduce((acc: Acc, message) => {
    const date = new Date(message.created_at).toISOString().split('T')[0]; // Extract the date part
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(message);
    return acc;
  }, {});
}

export const convertDateTime = (date: any) => new Intl.DateTimeFormat('fa-ir', {timeStyle: 'short', dateStyle: 'short'}).format(new Date(date))

export function enumToArray(enumObj: object): { label: string, value: string }[] {
  return Object.entries(enumObj).map(([key, value]) => ({
    label: value,
    value: key as string,
  }));
}

// Hook
export function useDebounce(value: string | undefined, delay: number) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value)
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler)
      }
    },
    [value, delay] // Only re-call effect if value or delay changes
  )
  return debouncedValue
}

var tdlte = new RegExp('^(0?941)')
var irancell = new RegExp('^(0?93)|^(0?94)|^(0?900)|^(0?901)|^(0?902)|^(0?903)|^(0?904)|^(0?905)')
var mci = new RegExp('^(0?91)|^(0?99)')
var rightel = new RegExp('^(0?92)')
var shatel = new RegExp('^(0?998)')
var aptel = new RegExp('^(0?9991)|^(0?9993)')

export const isDigitsOnly = (text: string) => {
  // الگوی منظم برای تطبیق اعداد انگلیسی، فارسی و عربی
  const digitPattern = /^[0-9۰-۹٠-٩]*$/;
  return digitPattern.test(text);
};

export const findOperator = (m: string): OperatorsName | null => {
  let mobile = m
  if (m.startsWith('98')) {
    mobile = m.replace('98', '0')
  }
  if (mobile) {
    if (shatel.test(mobile)) {
      return 'shatel'
    } else if (tdlte.test(mobile)) {
      return 'td-lte'
    } else if (aptel.test(mobile)) {
      return 'aptel'
    } else if (irancell.test(mobile)) {
      return 'irancell'
    } else if (mci.test(mobile)) {
      return 'mci'
    } else if (rightel.test(mobile)) {
      return 'rightel'
    } else {
      return null
    }
  }
  return null
}

export const getProducts = async (id: any) => {
  const packages = await get('packages')
  const charges = await get('charges')

  if (!packages && !charges) {
    return null
  }

  var product: any = [];
  packages.filter((d: any) => {
      product.push(...d.products.filter((e: any) => e.id === id))
  })

  let ch = charges.filter((s: any) => s.id === id)[0]

  return product[0] || ch
}

export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function disableSplash () {
  document.body.classList.remove('page-loading');
}

export function enableSplash () {
  document.body.classList.add('page-loading');
}

interface CategoryData {
  id: number;
  text: string;
  parent?: number;
  link?: string;
}

interface ProductCategory {
  id: number;
  name: string;
  data: CategoryData[];
  address: string;
}

interface Product {
  id: number;
  name: string;
  price: number;
  categories: ProductCategory[];
}

interface CategoryWithProducts {
  id: number;
  text: string;
  products: {
    id: number;
    name: string;
    price: number;
  }[];
}

export function buildCategories(products: Product[]): CategoryWithProducts[] {
  // همه‌ی دسته‌ها از همه محصولات
  let allCategories: CategoryData[] = [];
  products.forEach(p => {
    if (p.categories && p.categories[0] && p.categories[0].data) {
      allCategories.push(...p.categories[0].data);
    }
  });

  // نگه داشتن فقط اولین occurrence هر دسته
  const uniqueCategories: CategoryWithProducts[] = [];
  const seen = new Set<number>();

  allCategories.forEach(cat => {
    if (!seen.has(cat.id)) {
      seen.add(cat.id);
      uniqueCategories.push({
        id: cat.id,
        text: cat.text,
        products: []
      });
    }
  });

  // محصولات رو به دسته‌ی درستشون وصل کنیم
  products.forEach(product => {
    const address = product.categories[0].address;
    const category = uniqueCategories.find(c => c.id === Number(address));
    if (category) {
      category.products.push({
        id: product.id,
        name: product.name,
        price: product.price
      });
    }
  });

  return uniqueCategories;
}


export function getHijriLabel(currentMonth: DateObject) {
  const jalaliDate = currentMonth.convert(persian);

  const firstDay = new DateObject({
    calendar: persian,
    year: jalaliDate.year,
    month: jalaliDate.month.number,
    day: 1,
  });

  const lastDay = new DateObject({
    calendar: persian,
    year: jalaliDate.year,
    month: jalaliDate.month.number,
    day: jalaliDate.month.length,
  });

  const firstMoon = firstDay.convert(arabic).setLocale(arabic_ar);
  const lastMoon = lastDay.convert(arabic).setLocale(arabic_ar);

  const firstMonth = firstMoon.month;
  const lastMonth = lastMoon.month;

  if (firstMonth.number === lastMonth.number) {
    return firstMonth.name; 
  } else {
    return `${firstMonth.name} - ${lastMonth.name}`; 
  }
}

export function getGregorianLabel(currentMonth: DateObject) {
  const jalaliDate = currentMonth.convert(persian);

  const firstDay = new DateObject({
    calendar: persian,
    year: jalaliDate.year,
    month: jalaliDate.month.number,
    day: 1,
  });

  const lastDay = new DateObject({
    calendar: persian,
    year: jalaliDate.year,
    month: jalaliDate.month.number,
    day: jalaliDate.month.length
  });

  const firstMoon = firstDay.convert(gregorian)
  const lastMoon = lastDay.convert(gregorian)

  const firstMonth = firstMoon.month;
  const lastMonth = lastMoon.month;

  if (firstMonth.number === lastMonth.number) {
    return firstMonth.name;
  } else {
    return `${firstMonth.shortName} - ${lastMonth.shortName}`;
  }
}

export function diffInYMD(from: DateObject, to: DateObject = new DateObject({ calendar: persian })) {
  let years = to.year - from.year;
  let months = to.month.number - from.month.number;
  let days = to.day - from.day;

  if (days < 0) {
    // روزهای ماه قبل رو حساب کن
    const prevMonth = to.subtract(1, "month");
    days += prevMonth.month.length;
    months--;
  }

  if (months < 0) {
    months += 12;
    years--;
  }

  return { years, months, days };
}
